import { useState } from "react";
import Item from "./Item";
import Redeem from "./Redeem";
import { useGetStickerListQuery } from "../../services/apiSlice";
import { useNavigate } from "react-router-dom";

const TOTAL_SLOTS = 20;

const buildSlots = (data) => {
  if (data.length >= TOTAL_SLOTS) {
    return data.slice(0, TOTAL_SLOTS);
  }
  const remaining = TOTAL_SLOTS - data.length;
  const emptySlots = Array.from({ length: remaining }, (_, index) => ({
    id: `empty-${index}`,
    background: "transparent",
  }));
  return [...data, ...emptySlots];
};

const A = () => {
  const navigate = useNavigate();
  const { data } = useGetStickerListQuery();

  const [redeemItem, setRedeemItem] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);

  const handleOpenRedeem = (item) => {
    setRedeemItem(item);
  };

  const handleCloseRedeem = () => {
    setRedeemItem(null);
    setCurrentStep(1);
  };

  const handleGoBack = () => navigate("/profile");

  return (
    <>
      <section className="section-content py-[30px] overflow-auto">
        <div className="flex flex-col gap-3">
          <div className="w-[42px] h-[42px] rounded-full">
            <div
              onClick={handleGoBack}
              className="w-full h-full flex items-center justify-center"
            >
              <span
                className={`icon icon-arrow-left text-[#A0A0A0] text-[18px]`}
              />
            </div>
          </div>
          <p className="text-[32px] leading-none font-bold text-primary mb-6 tracking-[-0.02em]">
            Sticker Album
          </p>
        </div>
        <section className="rounded-2xl bg-light-grey p-[18px]">
          <div className="grid grid-cols-4 gap-x-4 gap-y-[18px]">
            {buildSlots(data?.data || []).map((item) => (
              <Item
                key={item.id}
                item={item}
                onOpenRedeem={handleOpenRedeem}
                setCurrentStep={setCurrentStep}
              />
            ))}
          </div>
        </section>
        <p
          className="text-center mt-20 mb-8 underline text-base text-mid-gray"
          onClick={() => navigate("/sticker/redemption-history")}
        >
          Redemption History
        </p>
      </section>
      <Redeem
        item={redeemItem}
        onClose={handleCloseRedeem}
        currentStep={currentStep}
      />
    </>
  );
};

export default A;
